export default __webpack_public_path__ + "static/media/hyperjump__aurora.6867569e.png";